export const config = {
  aliases: {
    sql: 'postgresql'
  },
  ignoreMissing: true
}
